import { Controller } from "@hotwired/stimulus"
import { pastHomeHeroHeading } from "../utils/home_hero_heading"

export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 100 },
    direction: { type: String, default: "top" }
  }

  connect() {
    this.lastScrollY = window.scrollY
    this.hidden = false
    this.handleScroll = this.handleScroll.bind(this)
    this.syncNavbarHeight = this.syncNavbarHeight.bind(this)
    window.addEventListener("scroll", this.handleScroll)
    window.addEventListener("resize", this.syncNavbarHeight)
    this.syncNavbarHeight()
    this.syncNavbarOffset()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
    window.removeEventListener("resize", this.syncNavbarHeight)
  }

  syncNavbarHeight() {
    document.documentElement.style.setProperty("--navbar-height", `${this.element.offsetHeight}px`)
  }

  syncNavbarOffset() {
    document.documentElement.style.setProperty("--navbar-visible", this.hidden ? "0" : "1")
  }

  handleScroll() {
    const currentScrollY = window.scrollY
    const homeHeroNav = this.element.classList.contains("home-hero-nav")
    const headingPassed = pastHomeHeroHeading(this.element)

    // Homepage hero: keep nav visible until the hero heading reaches the navbar
    if (homeHeroNav && !headingPassed) {
      this.show()
      this.lastScrollY = currentScrollY
      return
    }

    // Don't do anything if we haven't scrolled past the threshold (homepage skips this once heading is reached)
    if (currentScrollY < this.thresholdValue && !(homeHeroNav && headingPassed)) {
      this.show()
      this.lastScrollY = currentScrollY
      return
    }

    // Scroll down
    if (currentScrollY > this.lastScrollY && !this.hidden) {
      this.hide()
    } 
    // Scroll up
    else if (currentScrollY < this.lastScrollY && this.hidden) {
      this.show()
    }

    this.lastScrollY = currentScrollY
  }

  hide() {
    const translate = this.directionValue === "bottom" ? "200%" : "-100%"
    this.element.style.transform = `translateY(${translate})`
    this.element.style.transition = "transform 0.3s ease-in-out"
    this.hidden = true
    this.syncNavbarOffset()
  }

  show() {
    this.element.style.transform = "translateY(0)"
    this.element.style.transition = "transform 0.3s ease-in-out"
    this.hidden = false
    this.syncNavbarOffset()
  }
}
